import React from "react";
import Navbar from "./Navbar";

const Layout = ({ children }) => {
  return (
    <div className=" ">
      <Navbar />
      <div className="container mx-auto">
        <main>{children}</main>
      </div>
    </div>
  );
};

export default Layout;
